import { Helmet } from 'react-helmet'

import { GlobalStyle } from 'styles/global'
import { Home } from 'containers/home'
import { AppContextProvider, useAppContext } from 'context/app-context'
import { config } from 'config'

const PageTitle = () => {
  const { strings } = useAppContext()

  return (
    <Helmet>
      <title>{strings.title}</title>
    </Helmet>
  )
}

function App() {
  return (
    <>
      <Helmet
        htmlAttributes={{
          dir: config.language === 'en' ? 'ltr' : 'rtl',
          lang: config.language,
        }}
      />
      <GlobalStyle />
      <AppContextProvider>
        <PageTitle />
        <Home />
      </AppContextProvider>
    </>
  )
}

export default App
